import React from "react";

const InputWrapper = ({ children }) => {
  return <div id="input__wrapper">{children}</div>;
};

export default InputWrapper;
